import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import * as moment from 'moment';

@Component({
  selector: 'medical-appointment-queues-list',
  templateUrl: './queues-list.html',
})
export class MedicalAppointmentQueuesListComponent {

  @Output() queueSelected: EventEmitter<any> = new EventEmitter<any>();

  public selectableSettings: SelectableSettings = { enabled: true, mode: 'single' };
  public mySelection: any[] = [];
  public gridData: any[] = [];


  @Input() isloading = false;
  @Input() set queues(value: any) {
    if (!value) {
      this.mySelection = [];
      this.gridData = [];
      return;
    }

    value.forEach((o: any) => {
      o.combinedTime = `${moment.utc(moment.duration(o.timeBegin).asMilliseconds()).format("HH:mm")} - ` + 
        `${moment.utc(moment.duration(o.timeEnd).asMilliseconds()).format("HH:mm")}`;
    });

    this.gridData = value;
  }
}
